import { Spinner } from './LoadingSpinnerWithBackground.styled';

type Props = {
  backgroundColor?: string;
  className?: string;
  color?: string;
  size?: number;
};

export default function LoadingSpinnerWithBackground({
  size = 24,
  color,
  backgroundColor,
  className,
}: Props) {
  return (
    <Spinner size={size} color={color} backgroundColor={backgroundColor} className={className} />
  );
}
